import { PessoaFisica } from '@tivic-team/manager-ts/dist/grl';
import { TaxiPonto } from '@tivic-team/manager-ts/dist/mob';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { TaxiParada } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity';
import { DocumentoArquivoDTO } from './../ptc/documento-arquivo.dto';

export class PermissaoTaxiDTO extends Concessao{

    taxiParada: TaxiParada = void(0);
    taxiPonto: TaxiPonto = void(0);
    pessoaFisica: PessoaFisica = void(0);
    nrPlaca: string = void(0);
    stHabilitacaoPermissionario: number = void(0);
    stHabilitacaoAuxiliar: number = void(0);
    stTaximetro: number = void(0);
    stCRLV: number = void(0);
    stDocumentacoes: number = void(0);
    documentoArquivoDTO: Array<DocumentoArquivoDTO> = void(0);

    constructor(
        taxiParada?: TaxiParada,
        taxiPonto?: TaxiPonto,
        pessoaFisica?: PessoaFisica,
        nrPlaca?: string,
        stHabilitacaoPermissionario?: number,
        stTaximetro?: number,
        stCRLV?: number,
        stDocumentacoes?: number,
        documentoArquivoDTO?: Array<DocumentoArquivoDTO>
    ){
        super();
        this.taxiParada = taxiParada;
        this.taxiPonto = taxiPonto;
        this.pessoaFisica = pessoaFisica;
        this.nrPlaca = nrPlaca;
        this.stHabilitacaoPermissionario = stHabilitacaoPermissionario;
        this.stTaximetro = stTaximetro;
        this.stCRLV= stCRLV;
        this.stDocumentacoes= stDocumentacoes;
        this.documentoArquivoDTO = documentoArquivoDTO;
    }
}

export class PermissaoTaxiDTOList {
    items: Array<PermissaoTaxiDTO>;
    total: number;

    constructor() {}
}